export var AccountType;
(function (AccountType) {
    AccountType["Bank"] = "BANK";
    AccountType["CreditCard"] = "CREDIT_CARD";
    AccountType["Cash"] = "CASH";
    AccountType["EWallet"] = "E_WALLET";
})(AccountType || (AccountType = {}));
//# sourceMappingURL=account-type.enum.js.map